
const generateID = () => Math.random().toString(36).substring(7)

const buildParams = filters => Object.keys(filters)
  .reduce((acc, e) => `${acc}${e}=${filters[e]}&`, '?')
  .slice(0, -1)

export {
  generateID,
  buildParams
}